import { render, staticRenderFns } from "./HeatTransferVinylItem.vue?vue&type=template&id=f154fece&scoped=true"
import script from "./HeatTransferVinylItem.vue?vue&type=script&lang=js"
export * from "./HeatTransferVinylItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f154fece",
  null
  
)

export default component.exports